module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 3216
// module chunks = 0